import React, {useState, useEffect} from 'react'
import styled from 'styled-components';
import { fetchWrapper } from '../../utils/apiHandlers';
import Button from '../Button';
import { formatDate } from '../../utils/helperfunctions';

interface Prop{
  userid: string;
}
const QuestionsComp : React.FC<Prop>=({userid})=>{

  const [ questions, setquestions ] = useState([])

  const getKeywords = async () => {
    let response = await fetchWrapper.post("/api/analysis/getquestions", {userid: userid}).then(r=>r)
    setquestions(response.qa)    
  }
  

  return(
    <MainContainer>
      <Column>
        <SubHeader>Customer Questions and Generate Answers</SubHeader>
        <Button text='load' handleClick={()=>getKeywords()} />
        <RowHead>
          <ItemHeader style={{flex:0.1}}>#</ItemHeader>
          <ItemHeader>Question</ItemHeader>
          <ItemHeader>Generated Answer</ItemHeader>
          <ItemHeader style={{flex:0.25}}>Date</ItemHeader>
        </RowHead>
        {
          questions.length>0?
            questions.map((v:any, k: any) => (
              <Row>
                <Item style={{flex:0.1}}>{k+1}</Item>
                <Item>{v.question}</Item>
                <Item>{v.answer}</Item>
                <Item style={{flex:0.25}}>{formatDate(new Date(v.register_date), "M/d/y h:m")}</Item>
              </Row>
            ))
          
          :<></>
        }

      </Column>
    </MainContainer>
  );
}

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-items: center;
  width: 100%;
`

const RowHead = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  padding: 3px;
  border-bottom: 1px solid black;
  @media (max-width: 770px) {
    flex-direction: column;
  }
`

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  padding: 3px;
  border-bottom: 1px solid black;
  @media (max-width: 770px) {
    flex-direction: column;
  }&:hover{
    background-color: #eee;
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: #000;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  @media (max-width: 770px) {
    padding: 20px 50px;
  }
`
const SubHeader = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 22px;
    justify-content: flex-end;
    color: black;
`;

const ItemHeader = styled.div`
    display: flex;
    flex: 1;
    padding: 5px;
    font-weight: 700;
    font-size: 16px;
    color: black;
`;

const Item = styled.div`
    display: flex;
    flex: 1;  
    padding: 5px 10px;
    font-weight: 500;
    font-size: 12px;
    color: black;
    justify-content: flex-start;
    align-items: flex-start;
    word-break: break-all;
  `;

export default QuestionsComp